// Scroll-Reveal: [data-tg-reveal] blendet beim Eintritt in den Viewport ein.
// [data-tg-reveal-stagger] am Elternelement staffelt die Kinder.
// Nur Elemente unterhalb des Viewports werden versteckt; ohne JS bleibt alles sichtbar.
const SELECTOR = '[data-tg-reveal]';
const STATE = 'tgRevealState';
const motion = matchMedia('(prefers-reduced-motion: reduce)');
let observer;

function reveal(entries) {
  for (const entry of entries) {
    if (!entry.isIntersecting) continue;
    entry.target.dataset[STATE] = 'in';
    observer.unobserve(entry.target);
  }
}

function init(root = document) {
  if (motion.matches || !('IntersectionObserver' in window)) return;
  observer ??= new IntersectionObserver(reveal, { rootMargin: '0px 0px -8% 0px' });

  for (const el of root.querySelectorAll(`${SELECTOR}:not([data-tg-reveal-state])`)) {
    const { top } = el.getBoundingClientRect();
    if (top < window.innerHeight) {
      el.dataset[STATE] = 'in';
      continue;
    }
    const group = el.parentElement?.closest('[data-tg-reveal-stagger]');
    if (group) {
      const index = [...group.querySelectorAll(SELECTOR)].indexOf(el);
      el.style.setProperty('--tg-reveal-delay', `calc(var(--tg-stagger) * ${index % 8})`);
    }
    el.dataset[STATE] = 'pending';
    observer.observe(el);
  }
}

init();
document.addEventListener('shopify:section:load', (event) => init(event.target));
motion.addEventListener('change', () => {
  if (!motion.matches) return;
  for (const el of document.querySelectorAll('[data-tg-reveal-state="pending"]')) el.dataset[STATE] = 'in';
});
